import {
  GET_SCREENER_ROOMS,
  GET_SCREENER_ROOM_AVAILABLE_SCREENERS,
  GET_SCREENER_ROOM_AVAILABLE_PROJECTS,
  UPDATE_NEW_SCREENER_ROOM,
  TOGGLE_CREATE_ROOM_MODAL,
  CREATE_SCREENER_ROOM,
  GET_SCREENER_ROOM,
  ADD_SCREENERS_TO_ROOM,
  ADD_PROJECTS_TO_ROOM,
  GET_SCREENER_ANALYTICS,
  TOGGLE_ANALYTICS_MODAL,
  REMOVE_SCREENER_FROM_ROOM,
  REMOVE_PROJECT_FROM_ROOM,
  UPDATE_SCREENER_ROOM,
  //EXPIRE_ALL_VIEWERS,
  DELETE_SCREENER_ROOM,
  GENERATE_PREVIEW,
  TOGGLE_ADD_VIEWERS_MODAL,
  SET_SCREENER_ROOM,
  TOGGLE_SCREENER_ROOM_PERMISSIONS_MODAL,
  SAVE_SCREENER_GROUP_ACCESS,
  TOGGLE_SCREENER_GROUP_DELETE_MODAL,
  DUPLICATE_SCREENER_ROOM
} from "@actions/screener_rooms/"

import { get, post, put, del } from "@api/fetch"
import { push } from "connected-react-router"
//import moment from 'moment'
import { addGlobalMessage } from "@api/utils/"

/**
 * Get all of the screener rooms belonging to an organization
 *
 * @param  string  organizationId
 *
 * @return dispatch
 */
export const getScreenerRooms = (organizationId, take, skip, search, sorting) => dispatch =>
  dispatch(
    get(
      GET_SCREENER_ROOMS,
      `organizations/${organizationId}/screener-groups?take=${take}&skip=${skip}&search=${search}&sortBy=${sorting.sortBy}&sortDirection=${sorting.sortDirection}`
    )
  )

/**
 * Get a single screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 *
 * @return dispatch
 */
export const getScreenerRoom = (organizationId, screenerRoomId) => dispatch =>
  dispatch(get(GET_SCREENER_ROOM, `organizations/${organizationId}/screener-groups/${screenerRoomId}`))

/**
 * Get all of the projects that are not currently in the screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 *
 * @return dispatch
 */
export const getAvailableProjects = (organizationId, screenerRoomId) => dispatch =>
  dispatch(
    get(
      GET_SCREENER_ROOM_AVAILABLE_PROJECTS,
      `organizations/${organizationId}/screener-groups/${screenerRoomId}/available-projects`
    )
  )

/**
 * Get all of the screeners in a specified project that are not currently in the screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  string  projectId
 *
 * @return dispatch
 */
export const getAvailableScreeners = (organizationId, screenerRoomId, projectId) => dispatch =>
  dispatch(
    get(
      GET_SCREENER_ROOM_AVAILABLE_SCREENERS,
      `organizations/${organizationId}/screener-groups/${screenerRoomId}/projects/${projectId}/available-screeners`
    )
  )

/**
 * Updates the state of the text in the create screener input field
 *
 * @param  string  text
 *
 * @return dispatch
 */
export const updateNewScreenerRoom = text => dispatch => dispatch({ type: UPDATE_NEW_SCREENER_ROOM, payload: { text } })

/**
 * Toggles the shown/hidden state of the create room modal
 *
 * @return dispatch
 */
export const toggleCreateRoomModal = () => dispatch => dispatch({ type: TOGGLE_CREATE_ROOM_MODAL })

/**
 * Saves the new screener room and redirects to it
 *
 * @param  string  organizationId
 * @param  string  screenerGroupName
 *
 * @return dispatch
 */
export const createScreenerRoom = (organizationId, screenerGroupName) => dispatch =>
  dispatch(
    post(CREATE_SCREENER_ROOM, `organizations/${organizationId}/screener-groups`, { screenerGroupName }, res => {
      dispatch(push(`/screener-rooms/${res._id}`))
    })
  )

/**
 * Add projects to a screener room
 *
 * @param  string  organizationID
 * @param  string  screenerRoomID
 * @param  array   projectIDs
 *
 * @return dispatch
 */
export const addProjectsToRoom = (organizationID, screenerRoomID, projectIDs, callback) => dispatch =>
  dispatch(
    put(
      ADD_PROJECTS_TO_ROOM,
      `organizations/${organizationID}/screener-groups/${screenerRoomID}/projects`,
      { projectIDs },
      res => {
        callback()
        dispatch(addGlobalMessage(`Added project${projectIDs.length > 1 ? "s" : ""} to room!`, "success"))
      }
    )
  )

/**
 * Add screeners to a screener room
 *
 * @param  string  organizationID
 * @param  string  screenerRoomID
 * @param  string  projectID
 * @param  array   screenerIDs
 *
 * @return dispatch
 */
export const addScreenersToRoom = (
  organizationID,
  screenerRoomID,
  projectID,
  screenerIDs,
  notifyReviewers,
  callback
) => dispatch =>
  dispatch(
    put(
      ADD_SCREENERS_TO_ROOM,
      `organizations/${organizationID}/screener-groups/${screenerRoomID}/projects/${projectID}/screeners`,
      { screenerIDs, notifyReviewers },
      res => {
        callback()
        dispatch(addGlobalMessage(`Added screener${screenerIDs.length > 1 ? "s" : ""} to room!`, "success"))
      }
    )
  )

/**
 * Remove screener from room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  array   screenerId
 *
 * @return dispatch
 */
export const removeScreenerFromRoom = (
  organizationId,
  screenerRoomId,
  projectId,
  screenerId,
  notifyReviewers
) => dispatch =>
  dispatch(
    del(
      REMOVE_SCREENER_FROM_ROOM,
      `organizations/${organizationId}/screener-groups/${screenerRoomId}/projects/${projectId}/screeners/${screenerId}`,
      { notifyReviewers },
      res => {
        dispatch(addGlobalMessage("Removed screener from room!", "success"))
      }
    )
  )

/**
 * Remove project from room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  array   projectId
 *
 * @return dispatch
 */
export const removeProjectFromRoom = (organizationId, screenerRoomId, projectId, notifyReviewers) => dispatch =>
  dispatch(
    del(
      REMOVE_PROJECT_FROM_ROOM,
      `organizations/${organizationId}/screener-groups/${screenerRoomId}/projects/${projectId}`,
      { notifyReviewers },
      res => {
        dispatch(addGlobalMessage("Removed project from room!", "success"))
      }
    )
  )

/**
 * Update a screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  object  data | example: { key: 'name', value: 'New Screener Name' }
 *
 * @return dispatch
 */
export const updateScreenerRoom = (organizationId, screenerRoomId, data) => dispatch =>
  dispatch(put(UPDATE_SCREENER_ROOM, `organizations/${organizationId}/screener-groups/${screenerRoomId}`, data))

/**
 * Swap project positions in a screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  string  indexA
 * @param  string  indexB
 *
 * @return dispatch
 */
export const swapProjectPositions = (organizationId, screenerRoom, indexA, indexB) => dispatch => {
  // Also update the local state to make it feel more responsive
  const projects = [...screenerRoom.projects]
  const temp = projects[indexA]
  projects[indexA] = projects[indexB]
  projects[indexB] = temp
  dispatch(setScreenerRoom({ ...screenerRoom, projects }))
  dispatch(
    put(UPDATE_SCREENER_ROOM, `organizations/${organizationId}/screener-groups/${screenerRoom._id}/swap-projects`, {
      indexA,
      indexB
    }, res => {
      dispatch(addGlobalMessage("Project positions swapped!", "success"))
    })
  )
}
  

/**
 * Swap screener positions in a screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 * @param  string  projectId
 * @param  string  indexA
 * @param  string  indexB
 *
 * @return dispatch
 */
export const swapScreenerPositions = (organizationId, screenerRoom, projectId, indexA, indexB) => dispatch => {
  // Also update the local state to make it feel more responsive
  const projects = [...screenerRoom.projects]
  const projectIndex = projects.findIndex(p => p._id === projectId)
  if (projectIndex === -1) {
    return
  }
  const screeners = [...projects[projectIndex].screeners]
  const temp = screeners[indexA]
  screeners[indexA] = screeners[indexB]
  screeners[indexB] = temp
  projects[projectIndex].screeners = screeners
  dispatch(setScreenerRoom({ ...screenerRoom, projects }))
  dispatch(
    put(
      UPDATE_SCREENER_ROOM,
      `organizations/${organizationId}/screener-groups/${screenerRoom._id}/projects/${projectId}/swap-screeners`,
      { indexA, indexB }, res => {
        dispatch(addGlobalMessage("Screener positions swapped!", "success"))
      }
    )
  )

}

/**
 * Get the analytics for the screener
 *
 * @param  string  screenerRoomId
 * @param  string  screenerId
 *
 * @return dispatch
 */
export const getScreenerAnalytics = (screenerRoomId, screenerId) => dispatch =>
  dispatch(get(GET_SCREENER_ANALYTICS, `screener-groups/${screenerRoomId}/screener-analytics/${screenerId}`))

/**
 * Toggles the shown/hidden state of the analytics modal
 *
 * @return dispatch
 */
export const toggleAnalyticsModal = (screener = null) => dispatch =>
  dispatch({
    type: TOGGLE_ANALYTICS_MODAL,
    payload: { screenerId: screener ? screener._id : null }
  })

/**
 * Delete a screener room
 *
 * @param  string  organizationId
 * @param  string  screenerRoomId
 *
 * @return dispatch
 */
export const deleteScreenerRoom = (organizationId, screenerRoomId) => dispatch =>
  dispatch(
    del(DELETE_SCREENER_ROOM, `organizations/${organizationId}/screener-groups/${screenerRoomId}`, {}, () => {
      dispatch(push(`/screener-rooms`))
      dispatch(addGlobalMessage(`Screener room deleted.`, "success"))
    })
  )

/**
 * Generate the screener room preview
 *
 * @param  string  screenerRoomId
 *
 * @return dispatch
 */
export const generatePreview = screenerRoomId => dispatch =>
  dispatch(post(GENERATE_PREVIEW, `screener-groups/${screenerRoomId}/preview`))

/**
 * Toggle the shown / hidden state of modal
 *
 * @return dispatch
 */
export const toggleAddViewersModal = addType => dispatch => dispatch({ type: TOGGLE_ADD_VIEWERS_MODAL, addType })

export const setScreenerRoom = screenerRoom => dispatch =>
  dispatch({ type: SET_SCREENER_ROOM, payload: { screenerRoom } })

export const togglePermissionsModal = _id => dispatch =>
  dispatch({
    type: TOGGLE_SCREENER_ROOM_PERMISSIONS_MODAL,
    payload: { screenerRoomId: _id }
  })

export const updateUsersAccess = (roomId, ids) => (dispatch, getState) => {
  return dispatch(
    post(
      SAVE_SCREENER_GROUP_ACCESS,
      `organizations/${getState().user.auth.organization_id}/screener-groups/${roomId}/access`,
      { ids },
      () => dispatch(addGlobalMessage(`Saved!`, "success"))
    )
  )
}

export const duplicateScreenerRoom = (room, callback) => (dispatch, getState) => {
  return dispatch(
    post(
      DUPLICATE_SCREENER_ROOM,
      `organizations/${getState().user.auth.organization_id}/screener-groups/${room._id}/duplicate`,
      null,
      (response) => {
        dispatch(addGlobalMessage(`Screener room duplicated!`, "success"))
        callback(response._id)
      }
    )
  )
}

export const toggleScreenerDeleteModal = (screenerRoom = null) => dispatch =>
  dispatch({
    type: TOGGLE_SCREENER_GROUP_DELETE_MODAL,
    payload: { screenerRoom }
  })
